import { TutorialEnum } from "../store/tutorialModal.store";

/** 
 Each item of steps array can have next properties
`button` - text displayed on next/close button 
`navigate` - optional param, shows that app show navigate to selected menu item index together
             with default button action (show next step or close modal is its last step)
`pauseGame` - pause game while modal is displayed
*/

const modalData = {
  [TutorialEnum.Basics]: {
    level: 0,
    title: 'How To Play',
    steps: [{
      button: 'Next',
    },
    {
      button: 'Next',
    },
    {
      button: 'BATTLE!',
    }],
    pauseGame: true
  },
  [TutorialEnum.Dash]: {
    level: 1,
    title: 'Dash Moves',
    steps: [{
      button: 'BATTLE!'
    }],
    pauseGame: true
  },
  [TutorialEnum.Combos]: {
    level: 2,
    title: 'Combos',
    steps: [{
      button: 'BATTLE!'
    }],
    pauseGame: true
  },
  [TutorialEnum.CombosAdvanced]: {
    level: 3,
    title: 'Advanced Combos',
    steps: [{
      button: 'BATTLE!'
    }],
    pauseGame: true
  },
  [TutorialEnum.RangeWeapon]: {
    level: 4,
    title: 'Range Weapon Controls',
    steps: [{
      button: 'BATTLE!'
    }],
    pauseGame: true
  },
  'achievement-1': {
    steps: [{
      button: 'Next',
      navigate: 3
    },{
      button: 'GOT IT',
    }],
  },
  'achievement-2': {
    steps: [{
      button: 'Equip Now',
      navigate: 0
    },{
      button: 'GOT IT'
      }],
    prenavigate: 1
  },
  'achievement-3': {
    steps: [{
      button: `Let's get it`,
      navigate: 4
    }]
  },
  'achievement-4': {
    steps: [{
      button: 'Equip Pistol',
      navigate: 0
    }],
    prenavigate:1
  },
}

const useModalSettings = (tutorialId) => {
  return modalData[tutorialId];
};

export default useModalSettings;
